import { ViewerTypes } from '@customTypes/ViewerTypes';

export function getVisibility(viewerTypes: ViewerTypes | null, pageViewer: string): boolean {
  if (viewerTypes) {
    if (viewerTypes.data && viewerTypes.data.length > 0) {
      const index = viewerTypes.data.findIndex((item) => item.attributes.type === pageViewer);
      return index != -1;
    } else {
      return pageViewer == 'web';
    }
  } else {
    return true;
  }
}
